import { createContext, useState, useRef } from "react";
import { useGoogleMapsApi } from "./hooks/useGoogleMapsApi";
import { GOOGLE_MAPS_API_KEY } from "./util/keys";

const MapContext = createContext({});

const MapContextProvider = ({ children }) => {
  // Start loading google api as early as possible.
  const [google, googleLoadError] = useGoogleMapsApi(GOOGLE_MAPS_API_KEY);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [acceptanceData, setAcceptanceData] = useState(null);
  const [mapLoading, setMapLoading] = useState(true);
  const activeTooltip = useRef();
  const tooltipFocusTargetRef = useRef();

  return (
    <MapContext.Provider
      value={{
        google,
        googleLoadError,
        selectedCountry,
        setSelectedCountry,
        acceptanceData,
        setAcceptanceData,
        mapLoading,
        setMapLoading,
        activeTooltip,
        tooltipFocusTargetRef,
      }}
    >
      {children}
    </MapContext.Provider>
  );
};

export { MapContext, MapContextProvider };
